import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW, EDIT } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_CC_LIBRARY,
    StoreType,
    CcLibrarySetProps,
    LoadCcLibrarySetById,
    IsOwnerCcLibrarySet,
    IsLockedCcLibrarySet,
    setCcLibrarySetView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import Form from "./form"
import ItemList from "../itemList"


const SetView = ({
    setId = null,
}: CcLibrarySetProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const reloadView = useSelector((state: StoreType) => state.ccLibrarySet.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadCcLibrarySetById(setId, userData.accountId, project.id).then((res) => {
            dispatch(setCcLibrarySetView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, VIEW)
        : hasProjectAccess(PRM_CC_LIBRARY, VIEW)

    const editAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, EDIT)
        : hasProjectAccess(PRM_CC_LIBRARY, EDIT)

    const isOwner = IsOwnerCcLibrarySet(project.id, set, userData)
    const isLocked = IsLockedCcLibrarySet(project.id, set, userData)

    const allowedToView = viewAccess || isOwner
    const allowedToEdit = editAccess || isOwner

    if (!allowedToView) return <AccessDenied />
    if (!set) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewComplianceSet} # ${set.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Form />

                <ItemList
                    editAccess={allowedToEdit && !isLocked}
                    setId={setId}
                />
            </PageContent>
        </Container>
    )
}
export default SetView
